import Tabs from './Tabs';

export * from './types';

export default Tabs;
